import MuiTooltip from '@mui/material/Tooltip';
import type { ReactElement } from 'react';

interface TooltipProps {
  // Empty never opens: an expanded row already shows its label.
  title: string;
  children: ReactElement;
}

// To the right of a glyph-only row, on hover and keyboard focus. The child keeps its own aria-label,
// which wins over the one MUI derives from the title, so the name is never doubled.
export function Tooltip({ title, children }: TooltipProps): ReactElement {
  return (
    <MuiTooltip title={title} placement="right">
      {children}
    </MuiTooltip>
  );
}
